export default __webpack_public_path__ + "static/media/at-the-end.d63e52d8.png";